import React from "react";
import {Carousel} from "antd";
import SliderItem from "./SliderItem";

const SliderContainer = ({PATH}) => {

    const slider = [
        {
            bg: PATH+'metahut-owner.jpg',
            title: "The California Public Party",
            username: "vagif",
            plotID: "A12-278"
        },
        {
            bg: PATH+'metahut-owner.jpg',
            title: "The California Public Party",
            username: "vagif",
            plotID: "A12-278"
        },
        {
            bg: PATH+'metahut-owner.jpg',
            title: "The California Public Party",
            username: "vagif",
            plotID: "A12-278"
        },
    ]

    return (
        <Carousel autoplay className="px-8 pr-0 rounded-xl mb-20">
            {slider.map((slide,index) => {
                return (
                    <SliderItem slide={slide} key={index} />
                )
            })}
        </Carousel>
    )
}

export default SliderContainer;